// extracted by mini-css-extract-plugin
export default {"container":"adminSidePanel_container__86IrX","main":"adminSidePanel_main__HQrRJ"};